export const dispatchCustomEvent = (event: CustomEvent) => {
  window.dispatchEvent(event)
}
